var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"pa-3"},[_c('v-skeleton-loader',{attrs:{"max-width":"300","type":"list-item-avatar-two-line"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }